import NoDataStyles from "./NoData.module.scss";

import NoDataSvg from "../../assets/noDataFoundsvg.svg";
const NoData = ({ withBorder = false, text = "No data found" }: any) => {
  const includeBorder = withBorder ? NoDataStyles.withBorder : "";
  return (
    <div className={`${NoDataStyles.noDataText} ${includeBorder}`}>
      <img src={NoDataSvg} alt="" width="19px" height="19px" />
      <span>{text}</span>
    </div>
  );
};

export default NoData;
